import { LanguageService } from '@aando/core';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { RulesRuComponent } from './rules-ru/rules-ru.component';
import { RulesEnComponent } from './rules-en/rules-en.component';
@Component({
  selector: 'app-rules-text',
  imports: [NzFloatButtonModule, RulesRuComponent, RulesEnComponent],
  templateUrl: './rules-text.component.html',
  styleUrl: './rules-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RulesTextComponent {
  private readonly languageService = inject(LanguageService);

  readonly currentLanguage = computed(() => this.languageService.currentLanguage);
}
